<template>
  <div class="qrCode">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="二维码"
        width="1000px"
        top="10vh">
      <div id="content" style="display: flex;flex-direction: row;flex-wrap: wrap;">
        <div v-for="item in equipmentList" :key="item.pkid" style="width: 30%;margin-bottom: 5%;margin-right: 3%">
          <div :id="'qrCode'+item.pkid" align="center" class="qrCodes"/>
          <div :id="'name'+item.pkid" style="margin-top: 3%;width: 70%;margin-left: 15%">
            <div>
              <span>
                设备名称：
              </span>
              <span>
                {{item.name}}
              </span>
            </div>
            <div style="margin-top: 1%">
              <span>
                设备编号：
              </span>
              <span>
                {{item.no}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
        <el-button @click="print">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import constant from "../../../util/constant";

  export default {
    name:"QRCodes",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        equipmentList:[],
        item:[],
        equipment: {
          pkid: "",
          no: "",
          name: "",
          model: "",
          location: "",
          dealer: "",
          purchaseDate: "",
          emRepairOrder: {
            urgency: "",
            result: "",
            status: "",
          },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.equipmentList=[];
        this.equipmentList = row;
        this.equipment.pkid = "";
        this.equipment.no = "";
        this.equipment.name = "";
        this.equipment.model = "";
        this.equipment.location = "";
        this.equipment.dealer = "";
        this.equipment.purchaseDate = "";
        this.equipment.emRepairOrder.urgency = "";
        this.equipment.emRepairOrder.result = "";
        this.equipment.emRepairOrder.status = "";
        for(let item of this.equipmentList) {
          this.$nextTick(() => {
            document.getElementById("qrCode"+item.pkid).innerHTML = "";
            this.getData(item.pkid);
          });
        }
      },
      getData(id) {
        this.$http
          .get("basic", `equipments/${id}`)
          .then(resp => {
            console.log(resp);
            this.equipment.pkid = resp.pkid;
            this.equipment.no = resp.no;
            this.equipment.name = resp.name;
            this.equipment.model = resp.model;
            this.equipment.location = resp.location;
            this.equipment.dealer = resp.dealer;
            this.equipment.purchaseDate = resp.purchaseDate;
            if (resp.emRepairOrder !== null) {
              if (resp.emRepairOrder.urgency !== null) {
                this.equipment.emRepairOrder.urgency = constant.urgencyType[resp.emRepairOrder.urgency];
              }
              if (resp.emRepairOrder.status !== null) {
                this.equipment.emRepairOrder.status = constant.reportOrderStatus[resp.emRepairOrder.status];
              }
              if (resp.emRepairOrder.result !== null) {
                this.equipment.emRepairOrder.result = constant.result[resp.emRepairOrder.result];
              }
            }
            this.bindQRCode(this.equipment);
            // this.equipmentList.push(this.equipment);
          });
      },
      bindQRCode(row) {
        console.log(row.pkid);
        new QRCode(document.getElementById("qrCode"+row.pkid), {
          text: JSON.stringify(row),
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/H
        });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .qrCode{
    .qrCodes{
      img{
        margin: 0 auto!important;
      }
    }
  }
</style>
